var inter={
	initList:'gp-purchase-demand-confirm/initList',
	confirmList:"carry-out-notice-assign-confirm/list",
	getSearchFormModels:"carry-out-notice-assign/getSearchFormModels",
}



export default function interFaceF(key=0){
	return key?process.env.API_HOST+inter[key]:'';
}


// WEBPACK FOOTER //
// ./src/extend/interface.js